module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarCon",
    staticClass: "sidebar",
    class: {
      'sidebar-extract': _vm.sidebarExtracted
    },
    style: (_vm.sidebarStyle),
    on: {
      "mousewheel": function($event) {
        _vm.onMousewheel($event)
      },
      "scroll": function($event) {
        $event.stopPropagation();
        _vm.onScroll()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canExtract),
      expression: "canExtract"
    }],
    ref: "expander",
    staticClass: "menu-expand",
    style: (_vm.expanderStyle),
    attrs: {
      "title": _vm.descTitle
    }
  }, [_c('span', [_vm._v("收起左侧导航")]), _c('svg', {
    class: {
      'extracted': _vm.sidebarExtracted
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "20",
      "height": "20"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('path', {
    attrs: {
      "d": "M112.8 356h510.4c24.8 0 44.8 21.6 44.8 48.001s-20 48-44.8 48.001h-510.4c-24.8 0-44.8-21.6-44.8-48.001s20-48 44.8-48.001zM112.8 580h510.4c24.8 0 44.8 21.6 44.8 48.001s-20 48-44.8 48.001h-510.4c-24.8 0-44.8-21.6-44.8-48.001s20-48 44.8-48.001zM116 796h781.6c26.401 0 49.6 20.001 50.4 46.4 0.8 27.2-20.8 49.6-48.001 49.6h-781.6c-26.401 0-49.6-20.001-50.4-46.4-0.8-27.2 20.8-49.6 48.001-49.6zM948.001 356.8v318.4c0 0 0 0 0 0l-223.2-159.2c0 0 0 0 0 0l223.2-159.2c0-0.8 0-0.8 0 0zM900 236h-781.6c-26.401 0-49.6-20.001-50.4-46.4-0.8-27.2 20.8-49.6 48.001-49.6h781.6c26.401 0 49.6 20.001 50.4 46.4 0.8 27.2-20.8 49.6-48.001 49.6z"
    }
  })])]), _vm._l((_vm.sidebar), function(item) {
    return _c('section', {
      key: item.title,
      on: {
        "mouseenter": function($event) {
          _vm.sidebarExtracted && (item.focused = true)
        },
        "mouseleave": function($event) {
          _vm.sidebarExtracted && (item.focused = false)
        }
      }
    }, [_c('h2', {
      on: {
        "click": function($event) {
          item.expanded = !item.expanded
        }
      }
    }, [(item.iconName && item.iconColor) ? _c('span', {
      staticClass: "menu-icon",
      style: ({
        background: item.iconColor
      })
    }, [_c('i', {
      staticClass: "fa",
      class: ['fa-' + item.iconName]
    })]) : _vm._e(), _c('span', {
      staticClass: "menu-title"
    }, [_vm._v(_vm._s(item.title))]), _c('i', {
      staticClass: "arrow-toggle fa",
      class: {
        'fa-angle-down': item.expanded,
        'fa-angle-right': !item.expanded
      }
    })]), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sidebarExtracted ? item.focused : item.expanded),
        expression: "sidebarExtracted ? item.focused : item.expanded"
      }],
      staticClass: "submenu"
    }, _vm._l((item.links), function(link) {
      return _c('li', {
        key: link.name,
        staticClass: "submenu-item",
        on: {
          "click": function($event) {
            _vm.sidebarExtracted && (item.focused = false)
          }
        }
      }, [(!link.disabled) ? _c('router-link', {
        attrs: {
          "to": link.to
        }
      }, [_c('span', [_vm._v(_vm._s(link.name))]), (link.isNew) ? _c('i', {
        staticClass: "new-func"
      }) : _vm._e()]) : _vm._e(), (link.disabled) ? _c('a', {
        class: {
          'disabled': link.disabled
        }
      }, [_c('span', [_vm._v(_vm._s(link.name))]), (link.isNew) ? _c('i', {
        staticClass: "new-func"
      }) : _vm._e()]) : _vm._e()], 1)
    }))])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68e824d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68e824d6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/sidebar/unit.vue
// module id = 766
// module chunks = 0